import { Head, Link } from '@inertiajs/react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import { projectMemorySourceUrl } from '@/frontend/features/WhatsappKnowledge/sourceUrl'
import type { WhatsappCopy } from '@/frontend/features/WhatsappKnowledge/types'

interface Props {
  page_title: string; copy: WhatsappCopy; project: { id: string; name: string }
  evidence: { group_name: string; source_ref: string; next_cursor: string | null; messages: { source_ref: string; author: string; text: string; occurred_at: string; deleted: boolean }[] }
}
function WhatsappEvidence({ page_title, copy, project, evidence }: Props) {
  const next = `${projectMemorySourceUrl(project.id, evidence.source_ref)}&cursor=${evidence.next_cursor}`
  return <>
    <Head title={page_title} />
    <main className="h-full overflow-y-auto"><div className="mx-auto max-w-4xl px-6 py-8">
      <Link href={`/dashboard/discovery/project_whatsapp_sources?project_id=${project.id}`} className="text-sm text-muted-foreground">{copy.back}</Link>
      <h1 className="mb-6 mt-5 text-xl font-semibold">{evidence.group_name}</h1>
      <div className="divide-y border-y border-border">{evidence.messages.map((message) => <article key={message.source_ref} className="py-5"><header className="mb-2 flex items-center gap-3 text-xs"><span className="font-medium">{message.author}</span><time className="text-muted-foreground">{new Date(message.occurred_at).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}</time></header><p className="whitespace-pre-wrap text-sm leading-6">{message.deleted ? copy.message_deleted : message.text}</p></article>)}</div>
      {evidence.next_cursor && <Link href={next} className="mt-5 inline-block text-sm text-primary">{copy.more_messages}</Link>}
    </div></main>
  </>
}
WhatsappEvidence.layout = (page: React.ReactElement) => <DashboardLayout variant="fullscreen">{page}</DashboardLayout>
export default WhatsappEvidence
